import {
  Box,
  Button,
  Container,
  Grid,
  Select,
  MenuItem,
  Typography,
  FormControl,
  Switch,
  InputLabel,
  CircularProgress,
  FormControlLabel,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import {
  NotificationCampaignFirstFormSchema,
  NotificationCampaignSecondFormSchema,
  NotificationBannerCampaignSecondFormSchema,
  thirdFormNotificationValidationSchema,
  thirdFormBannerValidationSchema,
  thirdFormBannerValidationSchema2,
} from "../../utils/Validations";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import {
  getRequestWithToken,
  patchRequestWithToken,
  postRequest,
  deleteRequest,
} from "../../utils/ApiRequests";
import { useContext, useEffect, useRef, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../components/GlobalStateProvide/GlobalStateProvider";
import FocusError from "../../components/FocusError/FocusError";
import BackBtn from "../../components/backButton/BackBtn";
import { checkPermission } from "../../utils/userPermissions";
import Unauthorized from "../../components/unauthorized/Unauthorized";
import "./marketing.scss";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import LinearProgress from "@mui/material/LinearProgress";
import CreatableSelect from "react-select/creatable";
import SureYouWantToDeletModal from "../../components/SureYouWantToDeleteModal/SureYouWantToDeletModal";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DatePicker from "react-datepicker";

const CreateNotification = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [dataById, setDataById] = useState([]);
  const location = useLocation();
  const [showLoader, setShowLoader] = useState(true);

  const [canCreate, setCanCreate] = useState(true);
  const [canDelete, setCanDelete] = useState(true);
  const [canUpdate, setCanUpdate] = useState(true);
  const [canRead, setCanRead] = useState(true);
  const [isAccess, setisAccess] = useState([]);
  const [isIncludesValue, setisIncludesValue] = useState(true);

  const [initialValues2, setInitialValues2] = useState({
    pincode: "",
    schedule: "",

    tagTextEn: "",
    tagTextHi: "",
    tagTextHn: "",
    tagTextTa: "",
    tagTextTe: "",
    tagTextKn: "",
    tagTextBn: "",
    tagTextGu: "",
    tagTextMr: "",

    titleEn: "",
    titleHn: "",
    titleHi: "",
    titleTa: "",
    titleTe: "",
    titleKn: "",
    titleBn: "",
    titleGu: "",
    titleMr: "",

    redirectTo: "",

    bodyEn: "",
    bodyHn: "",
    bodyHi: "",
    bodyTa: "",
    bodyTe: "",
    bodyBn: "",
    bodyKn: "",
    bodyMr: "",
    bodyGu: "",

    ctaButtonTextEn: "",
    ctaButtonTextHn: "",
    ctaButtonTextHi: "",
    ctaButtonTextKn: "",
    ctaButtonTextBn: "",
    ctaButtonTextTa: "",
    ctaButtonTextTe: "",
    ctaButtonTextMr: "",
    ctaButtonTextGu: "",


    expiryDateAndTime: "",
    sendLater: "",
    scheduleTime: "",
    bannerType: "",

    jobIdd: "",
    linkk: "",
  });

  const [secondFormValues, setSecondFormValues] = useState({
    condition: "",
    pincode: "",
    jobId: "",
    radius: "",
    eligibleCount: 0,
    startDate: null,
    endDate: null,
  });

  const [thirdFormNotificationValues, setThirdFormNotificationValues] =
    useState({
      title: "",
      description: "",
      notificationTypeIs: "",
      jobIdIs: "",
      urlIs: "",

    });

  // banbner upload
  const [useImageBanner, setUseImageBanner] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);

  const handleToggle = (event) => {
    setUseImageBanner(event.target.checked);
  };

  const handleImageChange = (event, setFieldValue) => {
    const file = event.currentTarget.files[0];
    if (file) {
      setPreviewImage(URL.createObjectURL(file));
      setFieldValue("tagImage", file);
      console.log("file", file);
    }
  };

  const [editForm, setEditForm] = useState(false);
  const { handleSnackBar } = useContext(GlobalContext);

  const [formNumber, setFormNumber] = useState(1);

  const [firstFormValues, setFirstFormValues] = useState({
    notificationName: "",
    tag: null,
    notificationType: "",
    scheduledTime: "",
    modeOfSend: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [value, setValue] = useState(null);
  const [options, setOptions] = useState(null);
  const [campaignId, setCampaignId] = useState(null);
  const [loading, setLoading] = useState(null);

  const handleCreate = (inputValue, setFieldValue) => {
    setValue({ value: inputValue, label: inputValue });
    setFieldValue("tag", { value: inputValue, label: inputValue });
  };

  const scrollTargetRef = useRef(null);
  const navigate = useNavigate();

  const redirectToData = [
    { id: 1, name: "KYC Screen", value: "KYC_SCREEN" },
    { id: 2, name: "Profile Section", value: "PROFILE_SECTION" },
    { id: 3, name: "Saved Jobs", value: "SAVED_JOBS" },
    { id: 4, name: "Applied Jobs", value: "APPLIED_JOB" },
    { id: 5, name: "Employer", value: "EMPLOYER" },
    { id: 6, name: "Jobs", value: "JOBS" },
    { id: 7, name: "All Occupation", value: "ALL_OCCUPATION" },
    { id: 8, name: "All Sectors", value: "ALL_SECTORS" },
    { id: 8, name: "Job Detail", value: "JOB_DETAIL" },
    { id: 8, name: "Link", value: "LINK" },
  ];

  const handleSubmitFirstForm = async (values) => {
    setFormSubmitted(true);
    const {
      notificationName,
      tag,
      notificationType,
      scheduledTime,
      modeOfSend,
    } = values;

    let newFirstFormValues = new FormData();

    if (modeOfSend === "banner") {
      newFirstFormValues = {
        bannerType: 2,
        tag: tag.value,
        name: notificationName,
        type: notificationType,
        sendLater: scheduledTime ? scheduledTime : new Date().toISOString(),
      };

      setThirdFormNotificationValues((prevStat) => {
        return {
          ...prevStat,
          sendLater: scheduledTime ? scheduledTime : new Date().toISOString(),
        };
      });
    }

    if (modeOfSend === "mobile notification") {
      newFirstFormValues = {
        campaignName: notificationName,
        tag: tag.value,
        campaignType: notificationType,
        scheduledTime: scheduledTime ? scheduledTime : new Date().toISOString(),
        modeOfSend: modeOfSend,
      };
    }
    setFirstFormValues(values);

    try {
      let res = await postRequest(`admin/campaign/create`, newFirstFormValues);

      if (res.data.status === "Success") {
        setFormSubmitted(false);
        setFormNumber(2);
        modeOfSend === "banner"
          ? setCampaignId(res?.data?.data?._id)
          : setCampaignId(res?.data?.data?.campaignId);
      } else {
        setFormSubmitted(false);
        setIsLoading(false);
        handleSnackBar(true, res.data.msg, "error");
      }
    } catch (err) {
      setFormSubmitted(false);
      setIsLoading(false);
      handleSnackBar(true, err?.response?.data?.msg, "error");
    }
  };

  const conditionData = [
    { id: 1, label: "Job Id", value: "Job Id" },
    { id: 2, label: "Pincode", value: "Pincode" },
    { id: 3, label: "Not Applied on Job", value: "Not Applied on Job" },
    { id: 4, label: "KYC Not completed", value: "Kyc not completed" },
    { id: 5, label: "Last Activity 1 week ago", value: "Last Activity 1 Week" },
    {
      id: 6,
      label: "Last Activity 1 month ago",
      value: "Last Activity 1 Month",
    },
    { id: 7, label: "All Users", value: "All Users" },
  ];

  const datePickerRef = useRef(null);
  const onChange = (dates, setFieldValue) => {
    const [start, end] = dates;
    setFieldValue("startDate", start);
    setFieldValue("endDate", end);
    // setFieldValue("count", 0);
    // setFieldValue("eligibleCount", 0);
  };


  const handleSubmitSecondForm = async (values, { setFieldValue }) => {

    let startingDate = values.startDate
      ? values.startDate.toISOString()
      : new Date(new Date().setFullYear(new Date().getFullYear() - 2));
    let endingDate = values.endDate
      ? values.endDate.toISOString()
      : new Date().toISOString();

    const { condition, jobId, pincode, radius } = values;
    const { modeOfSend } = firstFormValues;
    setLoading(true);

    let formData = new FormData();
    formData = {
      campaignId: campaignId,
      condition: condition,
      modeOfSend: modeOfSend,
      pincode: pincode,
      range: radius,
      jobId: jobId,
      dateCriteria: {
        from: startingDate,
        till: endingDate
      }
    };
    console.log("values", formData);
    try {
      let res = await patchRequestWithToken(
        `admin/campaign/check-count`,
        formData
      );

      if (res.data.status === "Success") {
        setFormSubmitted(false);
        setFormNumber(2);
        setFieldValue("eligibleCount", res.data.totalCount);
        setSecondFormValues((prevStat) => {
          return {
            ...prevStat,
            eligibleCount: res.data.totalCount,
          };
        });
        setLoading(false);
      } else {
        setFormSubmitted(false);
        setLoading(false);
        handleSnackBar(true, res.data.msg, "error");
      }
    } catch (err) {
      setFormSubmitted(false);
      setLoading(false);
      handleSnackBar(true, err?.response?.data?.msg, "error");
    }
  };

  const handleSubmitSecondBannerForm = async (values, { setFieldValue }) => {
    const { condition, jobId, pincode, radius } = values;
    let ConditionValue = conditionData?.find(
      (item) => item.value === condition
    );
    setLoading(true);
    let formData = new FormData();
    formData = {
      condition: {
        value_type: ConditionValue.id,
        value: jobId || pincode,
        radius: radius,
      },
    };
    try {
      let res = await patchRequestWithToken(`admin/banner/count`, formData);

      if (res.data.status === "Success") {
        setFormSubmitted(false);
        setFormNumber(2);
        setFieldValue("eligibleCount", res.data.data);
        setSecondFormValues((prevStat) => {
          return {
            ...prevStat,
            pincode: pincode,
            jobId: jobId,
            radius: radius,
            condition: ConditionValue.id,
            eligibleCount: res.data.data,
          };
        });
        setLoading(false);
      } else {
        setFormSubmitted(false);
        setLoading(false);
        handleSnackBar(true, res.data.msg, "error");
        setFieldValue("eligibleCount", 0);
        setSecondFormValues((prevStat) => {
          return {
            ...prevStat,
            eligibleCount: 0,
          };
        });
      }
    } catch (err) {
      setFormSubmitted(false);
      setLoading(false);
      setFieldValue("eligibleCount", 0);
      setSecondFormValues((prevStat) => {
        return {
          ...prevStat,
          eligibleCount: 0,
        };
      });
      handleSnackBar(true, err?.response?.data?.msg, "error");
    }
  };

  const handleSubmit2 = async (values, { resetForm }) => {
    const {
      tagTextEn,
      tagTextHi,
      tagTextHn,
      tagTextTa,
      tagTextTe,
      tagTextKn,
      tagTextBn,
      tagTextGu,
      tagTextMr,
      titleEn,
      titleHi,
      titleHn,
      titleTa,
      titleTe,
      titleKn,
      titleBn,
      titleGu,
      titleMr,
      redirectTo,
      bodyEn,
      bodyHi,
      bodyHn,
      bodyTa,
      bodyTe,
      bodyBn,
      bodyKn,
      bodyMr,
      bodyGu,
      ctaButtonTextEn,
      ctaButtonTextHn,
      ctaButtonTextHi,
      ctaButtonTextKn,
      ctaButtonTextBn,
      ctaButtonTextTa,
      ctaButtonTextTe,
      ctaButtonTextMr,
      ctaButtonTextGu,
      expiryDateAndTime,
      bannerType,
      linkk,
      jobIdd,
    } = values;
    const { notificationType, condition, pincode, jobId, radius } =
      secondFormValues;

    let formData;

    const conditionObject = {
      value_type: condition,
      value: jobId || pincode || "",
      radius: radius,
    };

    if (useImageBanner) {
      formData = new FormData();

      formData.append("type", bannerType);
      formData.append("reference", redirectTo);
      formData.append("expiry", expiryDateAndTime);
      formData.append("sendLater", thirdFormNotificationValues?.sendLater || false);
      // formData.append("bannerType", notificationType);

      // formData.append("condition", JSON.stringify(conditionObject));
      formData.append("condition[value_type]", condition);
      formData.append("condition[value]", jobId || pincode || "");
      formData.append("condition[radius]", radius);

      formData.append("id", campaignId);
      formData.append("jobId", jobIdd);
      formData.append("url", linkk);
      formData.append("image", values.tagImage);
      formData.append("usertype", "banner");
    } else {
      formData = {
        chipTagText: {
          en: tagTextEn, hi: tagTextHi, hn: tagTextHn,
          ta: tagTextTa, te: tagTextTe, kn: tagTextKn,
          bn: tagTextBn, gu: tagTextGu, mr: tagTextMr
        },
        title: {
          en: titleEn, hi: titleHi, hn: titleHn,
          ta: titleTa, te: titleTe, kn: titleKn,
          bn: titleBn, gu: titleGu, mr: titleMr
        },
        body: {
          en: bodyEn, hi: bodyHi, hn: bodyHn,
          ta: bodyTa, te: bodyTe, kn: bodyKn,
          bn: bodyBn, gu: bodyGu, mr: bodyMr
        },
        ctaButton: {
          en: ctaButtonTextEn, hi: ctaButtonTextHi, hn: ctaButtonTextHn,
          ta: ctaButtonTextTa, te: ctaButtonTextTe, kn: ctaButtonTextKn,
          bn: ctaButtonTextBn, gu: ctaButtonTextGu, mr: ctaButtonTextMr
        },
        type: bannerType,
        reference: redirectTo,
        expiry: expiryDateAndTime,
        sendLater: thirdFormNotificationValues?.sendLater || false,
        // bannerType: notificationType,
        condition: {
          value_type: condition,
          value: jobId || pincode || "",
          radius: radius,
        },
        id: campaignId,
        jobId: jobIdd,
        url: linkk,
        // image and usertype are not needed here since it's not image banner
      };
    }

    setFormSubmitted(true);

    try {
      let res = await patchRequestWithToken(`admin/banner`, formData);
      if (res.data.status === "Success") {
        res = res?.data?.data;
        let response2 = await getRequestWithToken(
          `admin/banner/activate?id=${campaignId}`
        );
        if (response2.data.status === "Success") {
          handleSnackBar(true, response2.data.msg, "success");
          setFormSubmitted(false);
          setTimeout(() => {
            navigate("/notifications");
          }, 500);
        }
      } else {
        setFormSubmitted(false);
        handleSnackBar(true, res.data.msg, "error");
      }
    } catch (err) {
      setFormSubmitted(false);
      handleSnackBar(true, err?.response?.data?.msg, "error");
    }
  };

  const handleSubmitThirdNoficationForm = async (values, { resetForm }) => {
    setFormSubmitted(true);
    const { title, description } = values;
    const { modeOfSend } = firstFormValues;
    let formData = new FormData();
    // formData = {
    //   campaignId: campaignId,
    //   modeOfSend: modeOfSend,
    //   title: title,
    //   body: description,
    //   url: values.urlIs,
    //   jobId: values.jobIdIs,
    //   type: values.notificationTypeIs

    // };

    formData = {
      campaignId: campaignId,
      modeOfSend: modeOfSend,
      title: title,
      body: description,
      type: values.notificationTypeIs,
      ...(values.notificationTypeIs === "link" && { url: values.urlIs }),
      ...(values.notificationTypeIs === "new_job_posted_1" && { jobId: values.jobIdIs })
    };

    try {
      let res = await postRequest(`admin/campaign/notification`, formData);
      if (res.data.status === "Success") {
        let response2 = await patchRequestWithToken("admin/campaign/activate", {
          campaignId: campaignId,
        });
        if (response2.data.status === "Success") {
          handleSnackBar(true, res.data.msg, "success");
          setFormSubmitted(false);
          setTimeout(() => {
            navigate("/notifications");
          }, 500);
        }
      } else {
        setFormSubmitted(false);
        handleSnackBar(true, res.data.msg, "error");
      }
    } catch (err) {
      setFormSubmitted(false);
      handleSnackBar(true, err?.response?.data?.msg, "error");
    }
  };

  const deleteCampaign = async () => {
    try {
      let response;
      let { modeOfSend } = firstFormValues;
      if (modeOfSend === "mobile notification") {
        response = await deleteRequest(
          `/admin/campaign?campaignId=${campaignId}`
        );
      } else {
        response = await deleteRequest(`/admin/banner?id=${campaignId}`);
      }
      response = response.data;
      if (response?.status === "Success") {
        handleSnackBar(true, "Campaign canceled", "success");
        setOpenDeleteModal(false);
        navigate("/notifications");
      }
    } catch (err) {
      handleSnackBar(true, err?.response?.data?.msg, "error");
      setOpenDeleteModal(false);
    }
  };

  const checkPermissionFunc = () => {
    const resourceToUpdate = "Notifcation Campaign";
    const permissions = checkPermission(resourceToUpdate);
    setCanCreate(permissions.canCreate);
    setCanDelete(permissions.canDelete);
    setCanUpdate(permissions.canUpdate);
    setCanRead(permissions.canRead);
  };

  const againCheckPermissions = () => {
    // console.log("hello")
    const checkAccesInArray = localStorage.getItem("resourceNames");
    setisAccess(checkAccesInArray);
    isIncludes();
  };

  const isIncludes = () => {
    setisIncludesValue(isAccess.includes("Notifcation Campaign"));
  };

  const getTags = async () => {
    try {
      let response = await getRequestWithToken("admin/tags");
      response = response?.data;
      if (response.status === "Success") {
        let tags = response.data
          .filter((tag) => tag && tag !== "undefined")
          .map((tag) => ({
            label: tag.replace("_", " "),
            value: tag.replace("_", " "),
          }));

        setOptions(tags);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getTags();
  }, []);

  useEffect(() => {
    checkPermissionFunc();
    againCheckPermissions();

    if (location.state?._id) {
    } else {
      setShowLoader(false);
    }

    if (location.state?._id) {
      // const { candidate = {}, deleted = {} } = dataById;
      // const {
      //   schedule = "",
      //   title = "",
      //   body = "",
      //   scheduledTime = "",
      // } = candidate;
      // setFirstFormValues({
      //   schedule,
      //   title,
      //   body,
      //   scheduledTime,
      // });
      setEditForm(true);
    } else {
      setFirstFormValues({
        notificationName: "",
        tag: null,
        notificationType: "",
        scheduledTime: "",
        modeOfSend: "",
      });
      setEditForm(false);
    }
  }, [location.state, setFirstFormValues, dataById._id, isIncludesValue]);

  const optionsforNotificationType = [
    { label: "KYC Screen", value: "complete_kyc_1" },
    { label: "Profile Section", value: "complete_profile_1" },
    { label: "Employer", value: "employer_list" },
    { label: "Job", value: "new_job_posted_1" },
    { label: "URL", value: "link" },
  ];

  return isIncludesValue ? (
    <>
      <Box
        className="create-notification-campaign-section"
        ref={scrollTargetRef}
      >
        <Container>
          <Box className="create-notification-campaign">
            <Box
              className="headingPlusBackBtn"
              style={{ marginBottom: "20px" }}
            >
              <BackBtn />
              <h1 className="formHeadings" id="topEle">
                {editForm
                  ? "Update Notification"
                  : "Create Notification / Banner"}
              </h1>
            </Box>

            {formSubmitted && (
              <LinearProgress
                style={{
                  width: "100%",
                  position: "absolute",
                  left: "0",
                  top: "66px",
                  zIndex: "999",
                }}
              />
            )}

            {formNumber === 1 && (
              <Box className="create-notification-campaign-form-wrapper">
                <Formik
                  initialValues={firstFormValues}
                  validationSchema={NotificationCampaignFirstFormSchema}
                  onSubmit={handleSubmitFirstForm}
                  enableReinitialize
                >
                  {({ errors, values, setFieldValue, resetForm }) => (
                    <Form className="create-notification-campaign-form">
                      <Box className="backgroundStyle">
                        <Grid
                          container
                          spacing={2}
                          className="cstmForGridNotification spaceBetween"
                        >
                          <Grid item xs={12} sm={6} md={6}>
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={12} md={12}>
                                <Box className="form-control">
                                  <label
                                    className="form-label"
                                    htmlFor="notificationName"
                                  >
                                    {" "}
                                    Notification Name{" "}
                                    <span className="must-fill-fields">*</span>
                                  </label>
                                  <Field
                                    id="notificationName"
                                    type="text"
                                    placeholder="Enter Notification Name"
                                    name="notificationName"
                                    className="form-input"
                                    size="small"
                                  />
                                  {errors.notificationName && (
                                    <Box className="form-error">
                                      {errors.notificationName}
                                    </Box>
                                  )}
                                </Box>
                              </Grid>

                              <Grid item xs={12} sm={12} md={12}>
                                <Box className="form-control">
                                  <label
                                    className="form-label"
                                    htmlFor="notificationType"
                                  >
                                    Notification Sending Mode
                                    <span className="must-fill-fields">*</span>
                                  </label>
                                  <FormControl
                                    name="notificationType"
                                    fullWidth
                                    size="small"
                                  >
                                    {values.modeOfSend === "" && (
                                      <InputLabel shrink={false}>
                                        Select Notification Type
                                      </InputLabel>
                                    )}
                                    <Select
                                      className="cstmSelectBox"
                                      name="modeOfSend"
                                      id="modeOfSend"
                                      value={values.modeOfSend}
                                      onChange={(event) => {
                                        setFieldValue(
                                          "modeOfSend",
                                          event.target.value
                                        );
                                      }}
                                    >
                                      {[
                                        {
                                          id: 1,
                                          name: "Notification",
                                          value: "mobile notification",
                                        },
                                        {
                                          id: 2,
                                          name: "Banner",
                                          value: "banner",
                                        },
                                      ].filter((item) => {
                                        if (item.value === "banner") {
                                          return isAccess.includes("Banner Campaign"); // Use your condition here
                                        }
                                        return true;

                                      }).map((item, index) => {
                                        return (
                                          <MenuItem
                                            value={item?.value}
                                            key={index}
                                          >
                                            {item?.name}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl>
                                  {errors.modeOfSend && (
                                    <Box className="form-error">
                                      {errors.modeOfSend}
                                    </Box>
                                  )}
                                </Box>
                              </Grid>

                              <Grid item xs={12} sm={12} md={12}>
                                <Box className="form-control">
                                  <label className="form-label" htmlFor="tag">
                                    Notification Tag
                                    <span className="must-fill-fields">*</span>
                                  </label>
                                  <CreatableSelect
                                    isClearable
                                    isDisabled={isLoading}
                                    isLoading={isLoading}
                                    onChange={(newValue) => {
                                      setValue(newValue);
                                      setFieldValue("tag", newValue);
                                    }}
                                    onCreateOption={(inputValue) =>
                                      handleCreate(inputValue, setFieldValue)
                                    }
                                    options={options || []}
                                    value={value}
                                    placeholder="Select or create a  tag"
                                  />
                                  {errors.tag && (
                                    <Box className="form-error">
                                      {errors.tag}
                                    </Box>
                                  )}
                                </Box>
                              </Grid>

                              <Grid item xs={12} sm={12} md={12}>
                                <Box className="form-control">
                                  <label
                                    className="form-label"
                                    htmlFor="notificationType"
                                  >
                                    {" "}
                                    Notification Type{" "}
                                    <span className="must-fill-fields">*</span>
                                  </label>
                                  <Select
                                    className="cstmSelectBox"
                                    name="notificationType"
                                    id="notificationType"
                                    value={values.notificationType}
                                    onChange={(event) => {
                                      setFieldValue(
                                        "notificationType",
                                        event.target.value
                                      );
                                    }}
                                    displayEmpty
                                    renderValue={(selected) =>
                                      selected
                                        ? selected
                                        : "Select Notification Type"
                                    }
                                  >
                                    <MenuItem value="" disabled>
                                      Select Notification Type
                                    </MenuItem>
                                    <MenuItem value="marketing">
                                      Marketing
                                    </MenuItem>
                                    <MenuItem value="utility">Utility</MenuItem>
                                  </Select>

                                  {errors.notificationType && (
                                    <Box className="form-error">
                                      {errors.notificationType}
                                    </Box>
                                  )}
                                </Box>
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={12} sm={5} md={5}>
                            <Box
                              style={{
                                display: "flex",
                                marginTop: "-7px",
                                alignItems: "center",
                              }}
                            >
                              <Typography className="sendLater">
                                Send Later
                              </Typography>

                              <Switch
                                className="saveLaterSwitch"
                                checked={values.sendLater}
                                name="sendLater"
                                onChange={async () => {
                                  const newSendLaterValue = !values.sendLater;
                                  await setFieldValue(
                                    "sendLater",
                                    newSendLaterValue
                                  );
                                  if (values.sendLater) {
                                    setFieldValue("scheduledTime", null);
                                  }
                                }}
                              />
                            </Box>
                            {values.sendLater && (
                              <Grid container>
                                <Grid item xs={12} sm={12} md={12}>
                                  <Box className="form-control flexRow">
                                    <label
                                      className="form-label"
                                      htmlFor="date"
                                    >
                                      Date and Time
                                    </label>
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <DateTimePicker
                                        value={values.scheduledTime}
                                        className="cstmDateTimePicker"
                                        onChange={(newValue) => {
                                          const utcDate = new Date(
                                            newValue
                                          ).toISOString();

                                          setFieldValue(
                                            "scheduledTime",
                                            utcDate
                                          );
                                        }}
                                      />
                                    </LocalizationProvider>
                                  </Box>
                                  {errors.scheduledTime && (
                                    <Box className="form-error">
                                      {errors.scheduledTime}
                                    </Box>
                                  )}
                                </Grid>
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                      </Box>

                      <Box className="form-button-section">
                        <Button
                          className="form-button"
                          variant="contained"
                          onClick={() => {
                            resetForm();
                            setValue([]);
                          }}
                          color="error"
                        >
                          Cancel
                        </Button>

                        <Button
                          className="form-button"
                          variant="contained"
                          type="submit"
                          color="success"
                          disabled={formSubmitted}
                        >
                          Next
                        </Button>
                      </Box>
                      <FocusError handleSnackBar={handleSnackBar} />
                    </Form>
                  )}
                </Formik>
              </Box>
            )}

            {formNumber === 2 && (
              <Box className="create-notification-campaign-form-wrapper">
                <Box className="backgroundStyle">
                  <Formik
                    initialValues={secondFormValues}
                    validationSchema={
                      firstFormValues?.modeOfSend === "banner"
                        ? NotificationBannerCampaignSecondFormSchema
                        : NotificationCampaignSecondFormSchema
                    }
                    onSubmit={
                      firstFormValues?.modeOfSend === "banner"
                        ? handleSubmitSecondBannerForm
                        : handleSubmitSecondForm
                    }
                  >
                    {({ errors, values, setFieldValue }) => (
                      <Form className="create-notification-campaign-form">
                        <Grid
                          container
                          spacing={2}
                          className="cstmForGridNotification "
                          style={{ position: "relative" }}
                        >
                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <label className="form-label" htmlFor="condition">
                                Condition
                                <span className="must-fill-fields">*</span>
                              </label>
                              <FormControl
                                name="condition"
                                fullWidth
                                size="small"
                              >
                                {values.condition === "" && (
                                  <InputLabel shrink={false}>
                                    Select Condition
                                  </InputLabel>
                                )}
                                <Select
                                  className="cstmSelectBox"
                                  name="condition"
                                  id="condition"
                                  value={values.condition}
                                  onChange={async (event) => {
                                    await setFieldValue(
                                      "condition",
                                      event.target.value
                                    );
                                    await setFieldValue("radius", "");
                                    await setFieldValue("eligibleCount", 0);
                                    setSecondFormValues((prevStat) => {
                                      return {
                                        ...prevStat,
                                        eligibleCount: 0,
                                      };
                                    });
                                  }}
                                >
                                  {firstFormValues?.modeOfSend === "banner" && (
                                    <MenuItem value="Job Id">Job Id</MenuItem>
                                  )}

                                  {/* Render other condition data */}
                                  {conditionData
                                    ?.filter((item) => item.id !== 1)
                                    .map((item) => (
                                      <MenuItem
                                        value={item?.value}
                                        key={item?.id}
                                      >
                                        {item?.label}
                                      </MenuItem>
                                    ))}
                                </Select>
                              </FormControl>
                              {errors.condition && (
                                <Box className="form-error">
                                  {errors.condition}
                                </Box>
                              )}
                            </Box>
                          </Grid>

                          {values.condition === "All Users" && <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <label className="form-label">
                                Date Range
                              </label>

                              <Box
                                style={{
                                  border: "1px solid #c4c4c4",
                                  borderRadius: "5px",
                                  display: "flex",
                                  gap: "10px",
                                  padding: "5px",
                                  alignItems: "center",
                                  background: "#ffffff",
                                }}
                              >
                                <DatePicker
                                  selected={values.startDate}
                                  onChange={(dates) => {
                                    onChange(dates, setFieldValue);
                                  }}
                                  startDate={values.startDate}
                                  endDate={values.endDate}
                                  selectsRange
                                  ref={datePickerRef}
                                  disabled={values.dataSource === "CSV"}
                                  placeholderText="Select Date Range"
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  dateFormat="MMMM d, yyyy"
                                />
                                <CalendarMonthIcon
                                  onClick={() =>
                                    datePickerRef.current.setOpen(true)
                                  }
                                />
                              </Box>

                              {errors.dateRange && (
                                <Box className="form-error">
                                  {errors.dateRange}
                                </Box>
                              )}
                            </Box>
                          </Grid>}

                          {(values.condition === "Pincode" ||
                            firstFormValues?.modeOfSend === "banner") && (
                              <Grid item xs={12} sm={6} md={4}>
                                <Box className="form-control">
                                  <label className="form-label" htmlFor="radius">
                                    Enter Radius (Km)
                                    <span className="must-fill-fields">*</span>
                                  </label>
                                  <Field
                                    id="radius"
                                    type="number"
                                    placeholder="Enter Radius"
                                    name="radius"
                                    className="form-input"
                                    size="small"
                                    min="0"
                                  />
                                  {errors.radius && (
                                    <Box className="form-error">
                                      {errors.radius}
                                    </Box>
                                  )}
                                </Box>
                              </Grid>
                            )}

                          {values.condition === "Job Id" && (
                            <Grid item xs={12} sm={6} md={4}>
                              <Box className="form-control">
                                <label className="form-label" htmlFor="jobId">
                                  Job ID
                                  <span className="must-fill-fields">*</span>
                                </label>
                                <Field
                                  id="jobId"
                                  type="text"
                                  placeholder="Enter Job Id"
                                  name="jobId"
                                  className="form-input"
                                  size="small"
                                />
                                {errors.jobId && (
                                  <Box className="form-error">
                                    {errors.jobId}
                                  </Box>
                                )}
                              </Box>
                            </Grid>
                          )}

                          {values.condition === "Pincode" && (
                            <Grid item xs={12} sm={6} md={4}>
                              <Box className="form-control">
                                <label className="form-label" htmlFor="pincode">
                                  Pincode
                                  <span className="must-fill-fields">*</span>
                                </label>
                                <Field name="pincode">
                                  {({ field, form }) => (
                                    <input
                                      {...field}
                                      type="text"
                                      inputMode="numeric"
                                      pattern="[0-9]*"
                                      maxLength="6"
                                      placeholder="Enter Pincode"
                                      className="form-input"
                                      onChange={(e) => {
                                        const value = e.target.value
                                          .replace(/[^0-9]/g, "")
                                          .slice(0, 6);
                                        form.setFieldValue(field.name, value);
                                      }}
                                    />
                                  )}
                                </Field>
                                {errors.pincode && (
                                  <Box className="form-error">
                                    {errors.pincode}
                                  </Box>
                                )}
                              </Box>
                            </Grid>
                          )}

                          <Grid item xs={12} sm={12} md={12}>
                            <Grid container>
                              <Grid item xs={12} sm={4} md={8}></Grid>
                              <Grid item xs={12} sm={4} md={4}>
                                <Box
                                  style={{
                                    background: "white",
                                    padding: "10px",
                                    border: "1px solid lightgray",
                                    borderRadius: "10px",
                                    display: "flex",
                                    gap: "10px",
                                    justifyContent: "center",
                                    flexDirection: "column",
                                    alignItems: "center",
                                  }}
                                >
                                  <Typography>Number of target user</Typography>
                                  {loading ? (
                                    <CircularProgress />
                                  ) : (
                                    <Typography
                                      style={{
                                        fontSize: "40px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      {values.eligibleCount}
                                    </Typography>
                                  )}
                                </Box>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Box className="form-button-section">
                          <Button
                            className="form-button"
                            variant="contained"
                            color="success"
                            type="submit"
                            disabled={formSubmitted || loading}
                          >
                            Check count
                          </Button>
                        </Box>
                        <FocusError handleSnackBar={handleSnackBar} />
                      </Form>
                    )}
                  </Formik>
                </Box>
              </Box>
            )}

            {formNumber === 2 && (
              <Box
                className="create-notification-campaign-form-wrapper"
                style={{ marginTop: "10px" }}
              >
                <h2
                  style={{ marginBottom: "10px", textTransform: "capitalize" }}
                >{`${firstFormValues?.modeOfSend} Details`}</h2>
                {firstFormValues?.modeOfSend === "banner" ? (
                  <>
                    <Formik
                      initialValues={initialValues2}
                      validationSchema={!useImageBanner ? thirdFormBannerValidationSchema : thirdFormBannerValidationSchema2}
                      onSubmit={handleSubmit2}
                      enableReinitialize
                    >
                      {({ errors, values, setFieldValue, resetForm }) => (
                        <Form className="create-notification-campaign-form">
                          <Box>
                            <Box className="">
                              <Grid
                                container
                                spacing={2}
                                className="backgroundStyle "
                                style={{ position: "relative", paddingBottom: "20px", marginBottom: '40px', marginLeft: '0', width: "100%" }}
                              >

                                <Grid item xs={12} sm={6} md={4}>
                                  <Box className="form-control">
                                    <FormControlLabel
                                      control={
                                        <Switch
                                          checked={useImageBanner}
                                          onChange={handleToggle}
                                          color="primary"
                                        />
                                      }
                                      label="Use Image Banner"
                                    />
                                  </Box>
                                </Grid>
                              </Grid>
                              {!useImageBanner ? <Box>
                                <Grid
                                  container
                                  spacing={2}
                                  className="backgroundStyle  "
                                  style={{ position: "relative", paddingBottom: "20px", marginBottom: '40px', marginLeft: '0', width: "100%" }}
                                >
                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="tagTextEn"
                                      >
                                        Tag text (English)
                                        {values.bannerType != "boolean" && <span className="must-fill-fields">
                                          *
                                        </span>}
                                      </label>
                                      <Field
                                        id="tagTextEn"
                                        type="text"
                                        placeholder="Enter tag text (Max 11 Characters)"
                                        name="tagTextEn"
                                        className="form-input"
                                        size="small"
                                        maxLength="11"
                                      />
                                      {errors.tagTextEn && (
                                        <Box className="form-error">
                                          {errors.tagTextEn}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="tagTextHn"
                                      >
                                        Tag text (Hinglish)
                                        {values.bannerType != "boolean" && <span className="must-fill-fields">
                                          *
                                        </span>}
                                      </label>
                                      <Field
                                        id="tagTextHn"
                                        type="text"
                                        placeholder="Enter tag text (Max 11 Characters)"
                                        name="tagTextHn"
                                        className="form-input"
                                        size="small"
                                        maxLength="11"
                                      />
                                      {errors.tagTextHn && (
                                        <Box className="form-error">
                                          {errors.tagTextHn}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>

                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="tagTextHi"
                                      >
                                        Tag text (Hindi)
                                        {values.bannerType != "boolean" && <span className="must-fill-fields">
                                          *
                                        </span>}
                                      </label>
                                      <Field
                                        id="tagTextHi"
                                        type="text"
                                        placeholder="Enter tag text (Max 11 Characters)"
                                        name="tagTextHi"
                                        className="form-input"
                                        size="small"
                                        maxLength="11"
                                      />
                                      {errors.tagTextHi && (
                                        <Box className="form-error">
                                          {errors.tagTextHi}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>

                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="tagTextTe"
                                      >
                                        Tag text (Telugu)
                                        {values.bannerType != "boolean" && <span className="must-fill-fields">
                                          *
                                        </span>}
                                      </label>
                                      <Field
                                        id="tagTextTe"
                                        type="text"
                                        placeholder="Enter tag text (Max 11 Characters)"
                                        name="tagTextTe"
                                        className="form-input"
                                        size="small"
                                        maxLength="11"
                                      />
                                      {errors.tagTextTe && (
                                        <Box className="form-error">
                                          {errors.tagTextTe}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>

                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="tagTextTa"
                                      >
                                        Tag text (Tamil)
                                        {values.bannerType != "boolean" && <span className="must-fill-fields">
                                          *
                                        </span>}
                                      </label>
                                      <Field
                                        id="tagTextTa"
                                        type="text"
                                        placeholder="Enter tag text (Max 11 Characters)"
                                        name="tagTextTa"
                                        className="form-input"
                                        size="small"
                                        maxLength="11"
                                      />
                                      {errors.tagTextTa && (
                                        <Box className="form-error">
                                          {errors.tagTextTa}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="tagTextKn"
                                      >
                                        Tag text (Kannada)
                                        {values.bannerType != "boolean" && <span className="must-fill-fields">
                                          *
                                        </span>}
                                      </label>
                                      <Field
                                        id="tagTextKn"
                                        type="text"
                                        placeholder="Enter tag text (Max 11 Characters)"
                                        name="tagTextKn"
                                        className="form-input"
                                        size="small"
                                        maxLength="11"
                                      />
                                      {errors.tagTextKn && (
                                        <Box className="form-error">
                                          {errors.tagTextKn}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="tagTextGu"
                                      >
                                        Tag text (Gujarati)
                                        {values.bannerType != "boolean" && <span className="must-fill-fields">
                                          *
                                        </span>}
                                      </label>
                                      <Field
                                        id="tagTextGu"
                                        type="text"
                                        placeholder="Enter tag text (Max 11 Characters)"
                                        name="tagTextGu"
                                        className="form-input"
                                        size="small"
                                        maxLength="11"
                                      />
                                      {errors.tagTextGu && (
                                        <Box className="form-error">
                                          {errors.tagTextGu}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="tagTextMr"
                                      >
                                        Tag text (marathi)
                                        {values.bannerType != "boolean" && <span className="must-fill-fields">
                                          *
                                        </span>}
                                      </label>
                                      <Field
                                        id="tagTextMr"
                                        type="text"
                                        placeholder="Enter tag text (Max 11 Characters)"
                                        name="tagTextMr"
                                        className="form-input"
                                        size="small"
                                        maxLength="11"
                                      />
                                      {errors.tagTextMr && (
                                        <Box className="form-error">
                                          {errors.tagTextMr}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="tagTextBn"
                                      >
                                        Tag text (Bangali)
                                        {values.bannerType != "boolean" && <span className="must-fill-fields">
                                          *
                                        </span>}
                                      </label>
                                      <Field
                                        id="tagTextBn"
                                        type="text"
                                        placeholder="Enter tag text (Max 11 Characters)"
                                        name="tagTextBn"
                                        className="form-input"
                                        size="small"
                                        maxLength="11"
                                      />
                                      {errors.tagTextBn && (
                                        <Box className="form-error">
                                          {errors.tagTextBn}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>


                                </Grid>

                                <Grid
                                  container
                                  spacing={2}
                                  className="backgroundStyle  "
                                  style={{ position: "relative", paddingBottom: "20px", marginBottom: '40px', marginLeft: '0', width: "100%" }}
                                >

                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="titleEn"
                                      >
                                        Banner Title (English)
                                        <span className="must-fill-fields">
                                          *
                                        </span>
                                      </label>
                                      <Field
                                        id="titleEn"
                                        type="text"
                                        placeholder="Enter Banner Title (Max 30 Characters)"
                                        name="titleEn"
                                        className="form-input"
                                        size="small"
                                        maxLength="30"
                                      />
                                      {errors.titleEn && (
                                        <Box className="form-error">
                                          {errors.titleEn}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="titleHn"
                                      >
                                        Banner Title (Hinglish)
                                        <span className="must-fill-fields">
                                          *
                                        </span>
                                      </label>
                                      <Field
                                        id="titleHn"
                                        type="text"
                                        placeholder="Enter Banner Title (Max 30 Characters)"
                                        name="titleHn"
                                        className="form-input"
                                        size="small"
                                        maxLength="30"
                                      />
                                      {errors.titleHn && (
                                        <Box className="form-error">
                                          {errors.titleHn}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="titleHi"
                                      >
                                        Banner Title (Hindi)
                                        <span className="must-fill-fields">
                                          *
                                        </span>
                                      </label>
                                      <Field
                                        id="titleHi"
                                        type="text"
                                        placeholder="Enter Banner Title (Max 30 Characters)"
                                        name="titleHi"
                                        className="form-input"
                                        size="small"
                                        maxLength="30"
                                      />
                                      {errors.titleHi && (
                                        <Box className="form-error">
                                          {errors.titleHi}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="titleTe"
                                      >
                                        Banner Title (Telugu)
                                        <span className="must-fill-fields">
                                          *
                                        </span>
                                      </label>
                                      <Field
                                        id="titleTe"
                                        type="text"
                                        placeholder="Enter Banner Title (Max 30 Characters)"
                                        name="titleTe"
                                        className="form-input"
                                        size="small"
                                        maxLength="30"
                                      />
                                      {errors.titleTe && (
                                        <Box className="form-error">
                                          {errors.titleTe}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>


                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="titleTa"
                                      >
                                        Banner Title (Tamil)
                                        <span className="must-fill-fields">
                                          *
                                        </span>
                                      </label>
                                      <Field
                                        id="titleTa"
                                        type="text"
                                        placeholder="Enter Banner Title (Max 30 Characters)"
                                        name="titleTa"
                                        className="form-input"
                                        size="small"
                                        maxLength="30"
                                      />
                                      {errors.titleTa && (
                                        <Box className="form-error">
                                          {errors.titleTa}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>

                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="titleKn"
                                      >
                                        Banner Title (Kannada)
                                        <span className="must-fill-fields">
                                          *
                                        </span>
                                      </label>
                                      <Field
                                        id="titleKn"
                                        type="text"
                                        placeholder="Enter Banner Title (Max 30 Characters)"
                                        name="titleKn"
                                        className="form-input"
                                        size="small"
                                        maxLength="30"
                                      />
                                      {errors.titleKn && (
                                        <Box className="form-error">
                                          {errors.titleKn}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="titleBn"
                                      >
                                        Banner Title (Bangali)
                                        <span className="must-fill-fields">
                                          *
                                        </span>
                                      </label>
                                      <Field
                                        id="titleBn"
                                        type="text"
                                        placeholder="Enter Banner Title (Max 30 Characters)"
                                        name="titleBn"
                                        className="form-input"
                                        size="small"
                                        maxLength="30"
                                      />
                                      {errors.titleBn && (
                                        <Box className="form-error">
                                          {errors.titleBn}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="titleGu"
                                      >
                                        Banner Title (Gujarati)
                                        <span className="must-fill-fields">
                                          *
                                        </span>
                                      </label>
                                      <Field
                                        id="titleGu"
                                        type="text"
                                        placeholder="Enter Banner Title (Max 30 Characters)"
                                        name="titleGu"
                                        className="form-input"
                                        size="small"
                                        maxLength="30"
                                      />
                                      {errors.titleGu && (
                                        <Box className="form-error">
                                          {errors.titleGu}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="titleMr"
                                      >
                                        Banner Title (Marathi)
                                        <span className="must-fill-fields">
                                          *
                                        </span>
                                      </label>
                                      <Field
                                        id="titleMr"
                                        type="text"
                                        placeholder="Enter Banner Title (Max 30 Characters)"
                                        name="titleMr"
                                        className="form-input"
                                        size="small"
                                        maxLength="30"
                                      />
                                      {errors.titleMr && (
                                        <Box className="form-error">
                                          {errors.titleMr}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                </Grid>

                                <Grid
                                  container
                                  spacing={2}
                                  className="backgroundStyle "
                                  style={{ position: "relative", paddingBottom: "20px", marginBottom: '40px', marginLeft: '0', width: "100%" }}
                                >
                                  <Grid item xs={12} sm={12} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="bodyEn"
                                      >
                                        Banner Body (English)
                                        <span className="must-fill-fields">
                                          *
                                        </span>
                                      </label>
                                      <Field
                                        id="bodyEn"
                                        as="textarea"
                                        placeholder="Enter Banner body (Max 30 Characters)"
                                        name="bodyEn"
                                        className="form-input"
                                        rows={4}
                                        maxLength="30"
                                      />
                                      {errors.bodyEn && (
                                        <Box className="form-error">
                                          {errors.bodyEn}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={12} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="bodyHn"
                                      >
                                        Banner Body (Hinglish)
                                        <span className="must-fill-fields">
                                          *
                                        </span>
                                      </label>
                                      <Field
                                        id="bodyHn"
                                        as="textarea"
                                        placeholder="Enter Banner body (Max 30 Characters)"
                                        name="bodyHn"
                                        className="form-input"
                                        rows={4}
                                        maxLength="30"
                                      />
                                      {errors.bodyHn && (
                                        <Box className="form-error">
                                          {errors.bodyHn}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>

                                  <Grid item xs={12} sm={12} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="bodyHi"
                                      >
                                        Banner Body (Hindi)
                                        <span className="must-fill-fields">
                                          *
                                        </span>
                                      </label>
                                      <Field
                                        id="bodyHi"
                                        as="textarea"
                                        placeholder="Enter Banner body (Max 30 Characters)"
                                        name="bodyHi"
                                        className="form-input"
                                        rows={4}
                                        maxLength="30"
                                      />
                                      {errors.bodyHi && (
                                        <Box className="form-error">
                                          {errors.bodyHi}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={12} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="bodyTe"
                                      >
                                        Banner Body (Telugu)
                                        <span className="must-fill-fields">
                                          *
                                        </span>
                                      </label>
                                      <Field
                                        id="bodyTe"
                                        as="textarea"
                                        placeholder="Enter Banner body (Max 30 Characters)"
                                        name="bodyTe"
                                        className="form-input"
                                        rows={4}
                                        maxLength="30"
                                      />
                                      {errors.bodyTe && (
                                        <Box className="form-error">
                                          {errors.bodyTe}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={12} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="bodyTa"
                                      >
                                        Banner Body (Tamil)
                                        <span className="must-fill-fields">
                                          *
                                        </span>
                                      </label>
                                      <Field
                                        id="bodyTa"
                                        as="textarea"
                                        placeholder="Enter Banner body (Max 30 Characters)"
                                        name="bodyTa"
                                        className="form-input"
                                        rows={4}
                                        maxLength="30"
                                      />
                                      {errors.bodyTa && (
                                        <Box className="form-error">
                                          {errors.bodyTa}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={12} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="bodyKn"
                                      >
                                        Banner Body (Kannada)
                                        <span className="must-fill-fields">
                                          *
                                        </span>
                                      </label>
                                      <Field
                                        id="bodyKn"
                                        as="textarea"
                                        placeholder="Enter Banner body (Max 30 Characters)"
                                        name="bodyKn"
                                        className="form-input"
                                        rows={4}
                                        maxLength="30"
                                      />
                                      {errors.bodyKn && (
                                        <Box className="form-error">
                                          {errors.bodyKn}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={12} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="bodyBn"
                                      >
                                        Banner Body (Bangali)
                                        <span className="must-fill-fields">
                                          *
                                        </span>
                                      </label>
                                      <Field
                                        id="bodyBn"
                                        as="textarea"
                                        placeholder="Enter Banner body (Max 30 Characters)"
                                        name="bodyBn"
                                        className="form-input"
                                        rows={4}
                                        maxLength="30"
                                      />
                                      {errors.bodyBn && (
                                        <Box className="form-error">
                                          {errors.bodyBn}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={12} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="bodyGu"
                                      >
                                        Banner Body (Gujarati)
                                        <span className="must-fill-fields">
                                          *
                                        </span>
                                      </label>
                                      <Field
                                        id="bodyGu"
                                        as="textarea"
                                        placeholder="Enter Banner body (Max 30 Characters)"
                                        name="bodyGu"
                                        className="form-input"
                                        rows={4}
                                        maxLength="30"
                                      />
                                      {errors.bodyGu && (
                                        <Box className="form-error">
                                          {errors.bodyGu}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={12} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="bodyMr"
                                      >
                                        Banner Body (Marathi)
                                        <span className="must-fill-fields">
                                          *
                                        </span>
                                      </label>
                                      <Field
                                        id="bodyMr"
                                        as="textarea"
                                        placeholder="Enter Banner body (Max 30 Characters)"
                                        name="bodyMr"
                                        className="form-input"
                                        rows={4}
                                        maxLength="30"
                                      />
                                      {errors.bodyMr && (
                                        <Box className="form-error">
                                          {errors.bodyMr}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                </Grid>


                                <Grid
                                  container
                                  spacing={2}
                                  className="backgroundStyle "
                                  style={{ position: "relative", paddingBottom: "20px", marginBottom: '40px', marginLeft: '0', width: "100%" }}
                                >
                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="ctaButtonTextEn"
                                      >
                                        Cta Button Text (English)
                                        {values.bannerType != "boolean" && <span className="must-fill-fields">
                                          *
                                        </span>}
                                      </label>
                                      <Field
                                        id="ctaButtonTextEn"
                                        type="text"
                                        placeholder="Enter Cta Button Text (Max 15 Characters)"
                                        name="ctaButtonTextEn"
                                        className="form-input"
                                        size="small"
                                        maxLength="15"
                                      />
                                      {errors.ctaButtonTextEn && (
                                        <Box className="form-error">
                                          {errors.ctaButtonTextEn}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="ctaButtonTextHi"
                                      >
                                        Cta Button Text (Hindi)
                                        {values.bannerType != "boolean" && <span className="must-fill-fields">
                                          *
                                        </span>}
                                      </label>
                                      <Field
                                        id="ctaButtonTextHi"
                                        type="text"
                                        placeholder="Enter Cta Button Text (Max 15 Characters)"
                                        name="ctaButtonTextHi"
                                        className="form-input"
                                        size="small"
                                        maxLength="15"
                                      />
                                      {errors.ctaButtonTextHi && (
                                        <Box className="form-error">
                                          {errors.ctaButtonTextHi}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="ctaButtonTextHn"
                                      >
                                        Cta Button Text (Hinglish)
                                        {values.bannerType != "boolean" && <span className="must-fill-fields">
                                          *
                                        </span>}
                                      </label>
                                      <Field
                                        id="ctaButtonTextHn"
                                        type="text"
                                        placeholder="Enter Cta Button Text (Max 15 Characters)"
                                        name="ctaButtonTextHn"
                                        className="form-input"
                                        size="small"
                                        maxLength="15"
                                      />
                                      {errors.ctaButtonTextHn && (
                                        <Box className="form-error">
                                          {errors.ctaButtonTextHn}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="ctaButtonTextTe"
                                      >
                                        Cta Button Text (Telugu)
                                        {values.bannerType != "boolean" && <span className="must-fill-fields">
                                          *
                                        </span>}
                                      </label>
                                      <Field
                                        id="ctaButtonTextTe"
                                        type="text"
                                        placeholder="Enter Cta Button Text (Max 15 Characters)"
                                        name="ctaButtonTextTe"
                                        className="form-input"
                                        size="small"
                                        maxLength="15"
                                      />
                                      {errors.ctaButtonTextTe && (
                                        <Box className="form-error">
                                          {errors.ctaButtonTextTe}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="ctaButtonTextTa"
                                      >
                                        Cta Button Text (Tamil)
                                        {values.bannerType != "boolean" && <span className="must-fill-fields">
                                          *
                                        </span>}
                                      </label>
                                      <Field
                                        id="ctaButtonTextTa"
                                        type="text"
                                        placeholder="Enter Cta Button Text (Max 15 Characters)"
                                        name="ctaButtonTextTa"
                                        className="form-input"
                                        size="small"
                                        maxLength="15"
                                      />
                                      {errors.ctaButtonTextTa && (
                                        <Box className="form-error">
                                          {errors.ctaButtonTextTa}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="ctaButtonTextKn"
                                      >
                                        Cta Button Text (Kannada)
                                        {values.bannerType != "boolean" && <span className="must-fill-fields">
                                          *
                                        </span>}
                                      </label>
                                      <Field
                                        id="ctaButtonTextKn"
                                        type="text"
                                        placeholder="Enter Cta Button Text (Max 15 Characters)"
                                        name="ctaButtonTextKn"
                                        className="form-input"
                                        size="small"
                                        maxLength="15"
                                      />
                                      {errors.ctaButtonTextKn && (
                                        <Box className="form-error">
                                          {errors.ctaButtonTextKn}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="ctaButtonTextBn"
                                      >
                                        Cta Button Text (Bangali)
                                        {values.bannerType != "boolean" && <span className="must-fill-fields">
                                          *
                                        </span>}
                                      </label>
                                      <Field
                                        id="ctaButtonTextBn"
                                        type="text"
                                        placeholder="Enter Cta Button Text (Max 15 Characters)"
                                        name="ctaButtonTextBn"
                                        className="form-input"
                                        size="small"
                                        maxLength="15"
                                      />
                                      {errors.ctaButtonTextBn && (
                                        <Box className="form-error">
                                          {errors.ctaButtonTextBn}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="ctaButtonTextGu"
                                      >
                                        Cta Button Text (Gujarati)
                                        {values.bannerType != "boolean" && <span className="must-fill-fields">
                                          *
                                        </span>}
                                      </label>
                                      <Field
                                        id="ctaButtonTextGu"
                                        type="text"
                                        placeholder="Enter Cta Button Text (Max 15 Characters)"
                                        name="ctaButtonTextGu"
                                        className="form-input"
                                        size="small"
                                        maxLength="15"
                                      />
                                      {errors.ctaButtonTextGu && (
                                        <Box className="form-error">
                                          {errors.ctaButtonTextGu}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="ctaButtonTextMr"
                                      >
                                        Cta Button Text (Marathi)
                                        {values.bannerType != "boolean" && <span className="must-fill-fields">
                                          *
                                        </span>}
                                      </label>
                                      <Field
                                        id="ctaButtonTextMr"
                                        type="text"
                                        placeholder="Enter Cta Button Text (Max 15 Characters)"
                                        name="ctaButtonTextMr"
                                        className="form-input"
                                        size="small"
                                        maxLength="15"
                                      />
                                      {errors.ctaButtonTextMr && (
                                        <Box className="form-error">
                                          {errors.ctaButtonTextMr}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                </Grid>
                              </Box> :
                                (
                                  <Grid
                                    container
                                    spacing={2}
                                    className="backgroundStyle "
                                    style={{ position: "relative", paddingBottom: "20px", marginBottom: '40px', marginLeft: '0', width: "100%" }}
                                  >
                                    <Grid item xs={12} sm={6} md={6}>
                                      <Box className="form-control">
                                        <label className="form-label" htmlFor="tagImage">
                                          Upload Banner Image
                                          <span className="must-fill-fields">*</span>
                                        </label>
                                        <Field name="tagImage">
                                          {({ form, field }) => (
                                            <input
                                              id="tagImage"
                                              type="file"
                                              accept="image/*"
                                              className="form-input"
                                              onChange={(event) =>
                                                handleImageChange(event, form.setFieldValue)
                                              }
                                            />
                                          )}
                                        </Field>
                                        {errors.tagImage && (
                                          <Box className="form-error">{errors.tagImage}</Box>
                                        )}
                                      </Box>
                                    </Grid>

                                    {previewImage && (
                                      <Grid item xs={12} sm={6} md={6}>
                                        <Box className="form-control">
                                          <label className="form-label">Preview</label>
                                          <img
                                            src={previewImage}
                                            alt="Selected banner"
                                            style={{ width: "100%", maxHeight: 400, objectFit: "contain" }}
                                          />
                                        </Box>
                                      </Grid>
                                    )}
                                  </Grid>
                                )}
                              <Grid
                                container
                                spacing={2}
                                className="backgroundStyle "
                                style={{ position: "relative", paddingBottom: "20px", marginBottom: '40px', marginLeft: '0', width: "100%" }}
                              >
                                <Grid item xs={12} sm={6} md={4}>
                                  <Box className="form-control">
                                    <label
                                      className="form-label"
                                      htmlFor="bannerType"
                                    >
                                      Banner Type:
                                      <span className="must-fill-fields">
                                        *
                                      </span>
                                    </label>
                                    <FormControl
                                      name="bannerType"
                                      fullWidth
                                      size="small"
                                    >
                                      {values.bannerType === "" && (
                                        <InputLabel shrink={false}>
                                          Select Banner Type
                                        </InputLabel>
                                      )}
                                      <Select
                                        className="cstmSelectBox"
                                        name="bannerType"
                                        id="bannerType"
                                        value={values.bannerType}
                                        onChange={(event) => {
                                          setFieldValue(
                                            "bannerType",
                                            event.target.value
                                          );
                                        }}
                                      >
                                        {[
                                          {
                                            id: 1,
                                            label: "Question",
                                            value: "boolean",
                                          },
                                          {
                                            id: 2,
                                            label: "Redirect",
                                            value: "redirect",
                                          },
                                        ]?.map((item, index) => {
                                          return (
                                            <MenuItem
                                              value={item?.value}
                                              key={index}
                                            >
                                              {item?.label}
                                            </MenuItem>
                                          );
                                        })}
                                      </Select>
                                    </FormControl>
                                    {errors.bannerType && (
                                      <Box className="form-error">
                                        {errors.bannerType}
                                      </Box>
                                    )}
                                  </Box>
                                </Grid>

                                {values.bannerType === "redirect" && (
                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="redirectTo"
                                      >
                                        Redirect to:
                                        <span className="must-fill-fields">
                                          *
                                        </span>
                                      </label>
                                      <FormControl
                                        name="redirectTo"
                                        fullWidth
                                        size="small"
                                      >
                                        {values.redirectTo === "" && (
                                          <InputLabel shrink={false}>
                                            Select Redirect To
                                          </InputLabel>
                                        )}
                                        <Select
                                          className="cstmSelectBox"
                                          name="redirectTo"
                                          id="redirectTo"
                                          value={values.redirectTo}
                                          onChange={(event) => {
                                            setFieldValue(
                                              "redirectTo",
                                              event.target.value
                                            );
                                          }}
                                        >
                                          {redirectToData?.map(
                                            (item, index) => {
                                              return (
                                                <MenuItem
                                                  value={item?.value}
                                                  key={index}
                                                >
                                                  {item?.name}
                                                </MenuItem>
                                              );
                                            }
                                          )}
                                        </Select>
                                      </FormControl>
                                      {errors.redirectTo && (
                                        <Box className="form-error">
                                          {errors.redirectTo}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                )}



                                {values.redirectTo === "JOB_DETAIL" &&
                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="jobIdd"
                                      >
                                        Job ID
                                        <span className="must-fill-fields">
                                          *
                                        </span>
                                      </label>
                                      <Field
                                        id="jobIdd"
                                        type="text"
                                        placeholder="Enter jobId ex:- JYJ-00000"
                                        name="jobIdd"
                                        className="form-input"
                                        size="small"
                                        maxLength="15"
                                      />
                                      {errors.jobIdd && (
                                        <Box className="form-error">
                                          {errors.jobIdd}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                }
                                {values.redirectTo === "LINK" &&
                                  <Grid item xs={12} sm={6} md={4}>
                                    <Box className="form-control">
                                      <label
                                        className="form-label"
                                        htmlFor="linkk"
                                      >
                                        Link
                                        <span className="must-fill-fields">
                                          *
                                        </span>
                                      </label>
                                      <Field
                                        id="linkk"
                                        type="text"
                                        placeholder="Paste a Link"
                                        name="linkk"
                                        className="form-input"
                                        size="small"
                                      />
                                      {errors.linkk && (
                                        <Box className="form-error">
                                          {errors.linkk}
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                }




                                <Grid item xs={12} sm={6} md={4}>
                                  <Box className="form-control">
                                    <label
                                      className="form-label"
                                      htmlFor="expiryDateAndTime"
                                    >
                                      Expiry Date & Time
                                      <span className="must-fill-fields">
                                        *
                                      </span>
                                    </label>
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <DateTimePicker
                                        className="datePickerGetInput"
                                        label=""
                                        value={values.expiryDateAndTime}
                                        onChange={(newValue) => {
                                          setFieldValue(
                                            "expiryDateAndTime",
                                            newValue
                                          );
                                        }}
                                      />
                                    </LocalizationProvider>
                                    {errors.expiryDateAndTime && (
                                      <Box className="form-error">
                                        {errors.expiryDateAndTime}
                                      </Box>
                                    )}
                                  </Box>
                                </Grid>
                              </Grid>
                            </Box>

                            <Box
                              className="form-button-section"
                              style={{ marginTop: "10px" }}
                            >
                              <Button
                                className="form-button"
                                variant="contained"
                                onClick={() => {
                                  setOpenDeleteModal(true);
                                }}
                                color="error"
                                disabled={
                                  formSubmitted ||
                                  !Boolean(secondFormValues?.eligibleCount)
                                }
                              >
                                Cancel
                              </Button>

                              <Button
                                className="form-button"
                                variant="contained"
                                type="submit"
                                color="success"
                                disabled={
                                  formSubmitted ||
                                  !Boolean(secondFormValues?.eligibleCount)
                                }
                              >
                                {editForm ? "Update" : "Submit & Schedule"}
                              </Button>
                            </Box>
                            <FocusError handleSnackBar={handleSnackBar} />
                          </Box>
                        </Form>
                      )}
                    </Formik>
                  </>
                ) : (
                  <Formik
                    initialValues={thirdFormNotificationValues}
                    validationSchema={thirdFormNotificationValidationSchema}
                    onSubmit={handleSubmitThirdNoficationForm}
                    enableReinitialize
                  >
                    {({ errors, values, setFieldValue, resetForm }) => (
                      <Form className="create-notification-campaign-form">
                        <Box>
                          <Box className="backgroundStyle">
                            <Grid
                              container
                              spacing={2}
                              className="cstmFormGridEmployer"
                              style={{ position: "relative" }}
                            >
                              <Grid item xs={12} sm={6} md={4}>
                                <Box className="form-control">
                                  <label className="form-label" htmlFor="title">
                                    Notification Title
                                    <span className="must-fill-fields">*</span>
                                  </label>
                                  <Field
                                    id="title"
                                    type="title"
                                    placeholder="Enter Notification Title"
                                    name="title"
                                    className="form-input"
                                    size="small"
                                  // maxLength="11"
                                  />
                                  {errors.title && (
                                    <Box className="form-error">
                                      {errors.title}
                                    </Box>
                                  )}
                                </Box>
                              </Grid>

                              <Grid item xs={12} sm={12} md={12}>
                                <Box className="form-control">
                                  <label
                                    className="form-label"
                                    htmlFor="description"
                                  >
                                    Notification Body
                                    <span className="must-fill-fields">*</span>
                                  </label>
                                  <Field
                                    id="description"
                                    as="textarea"
                                    placeholder="Enter Notification body"
                                    name="description"
                                    className="form-input"
                                    rows={4}
                                  />
                                  {errors.description && (
                                    <Box className="form-error">
                                      {errors.description}
                                    </Box>
                                  )}
                                </Box>
                              </Grid>

                              <Grid item xs={12} sm={6} md={4}>
                                <Box className="form-control">
                                  <label
                                    className="form-label"
                                    htmlFor="notificationTypeIs"
                                  >
                                    {" "}
                                    Notification Type{" "}
                                    <span className="must-fill-fields">*</span>
                                  </label>
                                  <Select
                                    className="cstmSelectBox"
                                    name="notificationTypeIs"
                                    id="notificationTypeIs"
                                    value={values.notificationTypeIs}
                                    onChange={(event) => {
                                      setFieldValue("notificationTypeIs", event.target.value);
                                    }}
                                    displayEmpty
                                    renderValue={(selected) => {
                                      if (!selected) return "Select Notification Type"; // Default placeholder

                                      const selectedOption = optionsforNotificationType.find((option) => option.value === selected);
                                      return selectedOption ? selectedOption.label : selected; // Show label instead of value
                                    }}
                                  >
                                    <MenuItem value="" disabled>Select Notification Type</MenuItem>
                                    {optionsforNotificationType.map((option) => (
                                      <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                      </MenuItem>
                                    ))}
                                  </Select>

                                  {errors.notificationTypeIs && (
                                    <Box className="form-error">
                                      {errors.notificationTypeIs}
                                    </Box>
                                  )}
                                </Box>
                              </Grid>

                              {values.notificationTypeIs === "new_job_posted_1" && <Grid item xs={12} sm={6} md={4}>
                                <Box className="form-control">
                                  <label className="form-label" htmlFor="jobIdIs">
                                    JobId
                                    <span className="must-fill-fields">*</span>
                                  </label>
                                  <Field
                                    id="jobIdIs"
                                    type="jobIdIs"
                                    placeholder="Enter Job Id"
                                    name="jobIdIs"
                                    className="form-input"
                                    size="small"
                                  // maxLength="11"
                                  />
                                  <span style={{ color: 'grey', fontSize: '11px', fontWeight: "500", marginTop: "-5px" }}>ex:- JYJ-00000</span>
                                  {errors.jobIdIs && (
                                    <Box className="form-error">
                                      {errors.jobIdIs}
                                    </Box>
                                  )}
                                </Box>
                              </Grid>}
                              {values.notificationTypeIs === "link" && <Grid item xs={12} sm={6} md={4}>
                                <Box className="form-control">
                                  <label className="form-label" htmlFor="urlIs">
                                    URL
                                    <span className="must-fill-fields">*</span>
                                  </label>

                                  <Field
                                    id="urlIs"
                                    type="urlIs"
                                    placeholder="Enter URL"
                                    name="urlIs"
                                    className="form-input"
                                    size="small"
                                  // maxLength="11"
                                  />

                                  {/* <span style={{ color: 'grey', fontSize: '11px', fontWeight: "500", marginTop: "-5px" }}>URL must start with https://</span> */}
                                  {errors.urlIs && (
                                    <Box className="form-error">
                                      {errors.urlIs}
                                    </Box>
                                  )}
                                </Box>
                              </Grid>}
                            </Grid>
                          </Box>

                          <Box
                            className="form-button-section"
                            style={{ marginTop: "10px" }}
                          >
                            <Button
                              className="form-button"
                              variant="contained"
                              onClick={() => {
                                setOpenDeleteModal(true);
                              }}
                              color="error"
                              disabled={
                                !Boolean(secondFormValues?.eligibleCount)
                              }
                            >
                              Cancel
                            </Button>

                            <Button
                              className="form-button"
                              variant="contained"
                              type="submit"
                              color="success"
                              disabled={
                                formSubmitted ||
                                !Boolean(secondFormValues?.eligibleCount)
                              }
                            >
                              {editForm ? "Update" : "Submit & Schedule"}
                            </Button>
                          </Box>
                          <FocusError handleSnackBar={handleSnackBar} />
                        </Box>
                      </Form>
                    )}
                  </Formik>
                )}
              </Box>
            )}

            <SureYouWantToDeletModal
              modalTitle=""
              dialogBody={`Are you sure you want to cancel this ${firstFormValues?.modeOfSend === "banner"
                ? "banner"
                : "notification"
                } ?`}
              buttonText="Yes"
              openDeleteModal={openDeleteModal}
              setOpenDeleteModal={setOpenDeleteModal}
              onYesClick={() => {
                deleteCampaign(campaignId);
              }}
            />
          </Box>
        </Container>
      </Box>
    </>
  ) : (
    <Unauthorized />
  );
};
export default CreateNotification;
